import React from 'react';

export const createRaAuthProvider = () => auth => ({
    login: () => {
        if (!auth.isAuthenticated) {
            auth.signinRedirect();
        }
        return Promise.resolve();
    },

    logout: () => {
        auth.removeUser();
        auth.signoutRedirect();
        return Promise.resolve();
    },

    checkError: error => {
        const status = error?.status;
        return (status === 401 || status === 403)
            ? Promise.reject(auth.removeUser())
            : Promise.resolve();
    },

    checkAuth: () =>
        auth.isAuthenticated
            ? Promise.resolve()
            : Promise.reject({message: 'Not authenticated'}),

    getPermissions: () => {
        if (!auth.isAuthenticated) {
            return Promise.reject({message: 'Not authenticated'});
        }

        const providerType = process.env.REACT_APP_AUTH_PROVIDER || 'keycloak';
        let roles = providerType === 'keycloak'
            ? auth.user?.profile?.resource_access?.[
        process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'react-admin'
            ]?.roles || []
            : providerType === 'azure'
                ? auth.user?.profile?.roles || []
                : [];

        const scopeString = auth.user?.scope || '';
        const scopeRoles = scopeString.split(' ');
        roles = [...new Set([...roles, ...scopeRoles])];


        // console.debug('=== OIDC User Roles ===');
        // console.debug('Auth Provider Type:', providerType);
        // console.debug('User ID:', auth.user?.profile?.sub);
        // console.debug('Username:', auth.user?.profile?.preferred_username);
        // console.debug('Assigned Roles:', roles);
        // console.debug('Full profile:', auth.user?.profile);
        // console.debug('Full User:', auth.user);


        return Promise.resolve(roles);
    },

    getIdentity: () => {
        if (!auth.isAuthenticated || !auth.user) {
            return Promise.reject({message: 'Not authenticated'});
        }

        return Promise.resolve({
            id: auth.user.profile.sub,
            fullName: auth.user.profile.name || auth.user.profile.preferred_username,
            avatar: auth.user.profile.picture
        });
    }
});
